/** 
 * Fetches all users from the backend API.
 * @param {string} token - The access token for authentication (optional).
 * @returns {Promise<Array>} - A promise that resolves to the list of users.
 */
export const fetchAllUsers = async (token) => {
    try {
        const headers = new Headers();
        if (token) headers.append('Authorization', `Bearer ${token}`);
        const url = '/ros_be_app_directory/users/getUsers';
        //const url = 'http://localhost:5000/ros_be_app_directory/users/getUsers';
        const response = await fetch(url, { method: 'GET', headers });
        if (!response.ok) {
            throw new Error(`Error fetching applications: [${response.status}] [${response.statusText}]`);
        }
        return response;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
};



/**
 * Creates a new user in the backend.
 * @param {Object} userData - The data for the new user.
 * @param {string} token - The access token for authentication (optional).
 * @returns {Promise<Object>} - A promise that resolves to the created user object.
 */
export const createUser = async (userData, token) => { 
    try {
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      if (token) headers.append('Authorization', `Bearer ${token}`);
      const url = '/ros_be_app_directory/users/create';
      //const url = 'http://localhost:5000/ros_be_app_directory/users/create';
      const response = await fetch(url, {
        method: 'POST',
        headers, 
        body: userData, 
      });
  
      if (!response.ok) {
        throw new Error(`Error creating user: [${response.status}] [${response.statusText}]`);
      }
  
      return response;
    } catch (error) {
      console.error("Error creating user:", error);
      throw error;
    }
  };
  
  

/**
 * Deletes an users by its email.
 * @param {string} email - The email of the user to delete.
 * @param {string} token - The access token for authentication (optional).
 * @returns {Promise<Object>} - A promise that resolves to a success message.
 */
export const deleteUser = async (email, token) => {
    try {
        const headers = new Headers();
        if (token) headers.append('Authorization', `Bearer ${token}`);
        const url = `/ros_be_app_directory/users/delete/${email}`;
        //const url = `http://localhost:5000/ros_be_app_directory/users/delete/${email}`;
        const response = await fetch(url, { method: 'DELETE', headers });

        if (!response.ok) {
            throw new Error(`Error deleting user with email ${email}: [${response.status}] [${response.statusText}]`);
        }

        return await response.json();
    } catch (error) {
        console.error(`Error deleting user with email ${email}:`, error);
        throw error;
    }
};

